import React, { useMemo, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Spin, Tag } from "antd";
import TableContainerMin from "../../../Components/Common/TableContainerMin";
import { getUninspectionVehicle, relanceUninspectionVehicle } from "../services/inspectionApi";
import { useQuery } from "react-query";
import toast from "react-hot-toast";

const Relance = ({ modal, toggle }) => {
  const [isRelanceLoading, setIsRelanceLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const {
    data: UninspectonVehicle,
    isLoading,
    isError,
    error
  } = useQuery("relances", getUninspectionVehicle);

  const openConfirmModal = () => setConfirmModal(true);
  const closeConfirmModal = () => setConfirmModal(false);

  const handleRelance = async () => {
    setIsRelanceLoading(true);
    try {
      await relanceUninspectionVehicle();
      toast.success("Les relances ont été envoyées avec succès !");
      closeConfirmModal();
    } catch (err) {
      console.error("Erreur lors de la relance :", err);
      toast.error("Échec de l'envoi des relances");
    } finally {
      setIsRelanceLoading(false);
    }
  };

  const columns = useMemo(() => [
    { Header: "Marque", accessor: "brand", filterable: false },
    { Header: "Modele", accessor: "model", filterable: false },
    { Header: "Plaque", accessor: "registrationNumber", filterable: false },
    {
      Header: "Chauffeur",
      accessor: "actualUserName",
      Cell: ({ row }) => (
        <div>{row.original.actualUserName || "-"}</div>
      ),
      filterable: false,
    },
    {
      Header: "Statut",
      accessor: "statut",
      Cell: ({ value }) => (
        <span className={`badge bg-${value === "En service" ? "success" : "danger"}-subtle text-${value === "En service" ? "success" : "danger"}`}>
          {value}
        </span>
      ),
      filterable: false,
    },
  ], []);

  return (
    <>
      <Modal
        id="showModalClient"
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop={"static"}
        style={{ maxWidth: "1000px" }}
      >
        <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
          Relance des chauffeurs en retard d'inspections
        </ModalHeader>

        <ModalBody>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="text-title">
              En retard{" "}
              <Tag color="#5ea8adff" style={{ fontSize: "12px" }}>
                {UninspectonVehicle?.length || 0}
              </Tag>
            </div>
            <Button
              className="active-tab mb-4"
              disabled={UninspectonVehicle?.length === 0 && !isLoading && !isError}
              onClick={openConfirmModal}
            >
              Envoyer les relances
            </Button>
          </div>

          <TableContainerMin
            columns={columns}
            data={UninspectonVehicle || []}
            isGlobalSearch={true}
            isGlobalFilter={true}
            customPageSize={10}
            className="custom-header-css"
            divClass="table-responsive table-card mb-3"
            tableClass="align-middle table-nowrap"
            theadClass="table-light"
            SearchPlaceholder="Recherche..."
          />

          {isLoading && !isError && (
            <div className="text-center">
              Chargement des véhicules, merci de patienter... <Spin />
            </div>
          )}
          {UninspectonVehicle?.length === 0 && !isLoading && !isError && (
            <div className="text-center">
              Tous les véhicules ont été inspectés.
            </div>
          )}
          {isError && !isLoading && (
            <div className="text-center">
              Erreur lors du chargement : {error.message}
            </div>
          )}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={confirmModal}
        toggle={closeConfirmModal}
        centered
        backdrop="static"
      >
        <ModalHeader toggle={closeConfirmModal}>
          Confirmation de l’envoi
        </ModalHeader>
        <ModalBody className="text-center">
          {isRelanceLoading ? (
            <div className="py-5">
              <Spin size="large" />
              <div className="mt-3">Envoi des relances en cours...</div>
            </div>
          ) : (
            <>
              <p>Vous etes sur le point d'envoyer des relances aux {UninspectonVehicle?.length || 0} chauffeurs restant ?</p>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button className="btn btn-soft-secondary" onClick={closeConfirmModal}>
                  Annuler
                </Button>
                <Button className="active-tab" onClick={handleRelance}>
                  Confirmer
                </Button>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default Relance;
